import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService, UserService } from 'src/app/core';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
})
export class AddTaskComponent {
  public isEditMode: boolean = false;
  task: any;
  public form: FormGroup;
  readonly dialogRef = inject(MatDialogRef<AddTaskComponent>)
  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: any,
    private fb: FormBuilder,
    private adminService: AdminService,
    private snackBar: MatSnackBar
  ) {
    this.form = fb.group({
      persianName: [null, Validators.required],
      englishName: [null, Validators.required],
      score: ['0'],
    });
    if (dialogData.editMode) this.isEditMode = dialogData.editMode;
    if (dialogData.task) {
      this.task = dialogData.task;
      this.fillForm();
    }
  }

  fillForm() {
    this.form.controls['persianName'].setValue(this.task.persianName);
    this.form.controls['englishName'].setValue(this.task.englishName);
    this.form.controls['score'].setValue(this.task.score);
  }

  updateTask() {
    let request = this.form.value;
    request = { ...request, id: this.task.id };
    this.adminService.updateTask(request).subscribe((res: any) => {
      if (res) {
        this.snackBar.open('امتیاز با موفقیت به‌روز رسانی شد.', '', {
          duration: 1000,
        });
        setTimeout(() => {
          this.dialogRef.close();
        }, 100);
      }
    });
  }
  addTask() {
    const request = this.form.value;
    if (request.score) request.score = +request.score;
    this.adminService.addNewTask(request).subscribe((res: any) => {
      if (res) {
        this.snackBar.open('امتیاز با موفقیت اضافه شد.', '', {
          duration: 1000,
        });
        setTimeout(() => {
          this.dialogRef.close();
        }, 100);
      }
    });
  }
}
